/* eslint class-methods-use-this: 0 */

const consentElementId = "cookie-consent";

const acceptAllClass = "cookie-consent__accept-all-btn";
const acceptAllSelector = ".cookie-consent__accept-all-btn";

const acceptRequiredClass = "cookie-consent__accept-required-btn";
const acceptRequiredSelector = ".cookie-consent__accept-required-btn";

const openSettingsClass = "cookie-consent__open-settings";
const openSettingsSelector = ".cookie-consent__open-settings";

const backgroundDivID = "cookie_background";

export default class ConsentWindow {
    /**
     *
     * @param {EventDispatcher} eventDispatcher
     * @param {Configuration} configuration
     */
    constructor(eventDispatcher, configuration) {
        this.eventDispatcher = eventDispatcher;
        this.configuration = configuration;
    }

    /**
     * Creates new DOM element based on configuration
     * and attaches it under parent
     * @param {HTMLElement} parent
     */
    createConsent(parent) {
        // User needs to be able to read legal notice without accepting anything
        if (this.isLegalNoticePage() || this.isPageDenied()) {
            return;
        }

        this.consentElement = document.createElement("div");
        this.consentElement.id = consentElementId;

        const config = {
            text: this.configuration.ConsentDescription,
            settingsText: this.configuration.OpenSettingsText,
            allowText: this.configuration.AllowAllCookiesText,
            legalNoticeLink: this.configuration.LegalNoticeLink,
            legalNoticeText: this.configuration.LegalNoticeText,

            allowRequiredText: this.configuration.AllowRequiredCookiesText,
        };
        this.consentElement.innerHTML = this.consentHtml(config);

        parent.insertBefore(this.consentElement, parent.firstChild);

        var parent = this.consentElement.parentNode;
        var wrapper = document.createElement('div');
        wrapper.id = backgroundDivID;

        // set the wrapper as child (instead of the element)
        parent.replaceChild(wrapper, this.consentElement);
        // set element as child of wrapper
        wrapper.appendChild(this.consentElement);

        const openSettingsBtns = Array.prototype.slice.call(document.querySelectorAll(openSettingsSelector));
        openSettingsBtns.forEach((element) => {
            element.addEventListener("click", () => {
                this.eventDispatcher.openSettings();
                this.hide();
            }, false);
        });

        const acceptAllBtns = Array.prototype.slice.call(document.querySelectorAll(acceptAllSelector));
        acceptAllBtns.forEach((element) => {
            element.addEventListener("click", () => {
                this.eventDispatcher.acceptAll();
                this.hide();
            }, false);
        });

        const acceptRequiredBtns = Array.prototype.slice.call(document.querySelectorAll(acceptRequiredSelector));
        acceptRequiredBtns.forEach((element) => {
            element.addEventListener("click", () => {
                this.eventDispatcher.acceptRequired();
                this.hide();
            }, false);
        });
    }

    isLegalNoticePage() {
        const { location } = document;
        const legalLink = this.configuration.LegalNoticeLink;
        return (location.pathname.toString() === legalLink || location.href.toString() === legalLink);
    }

    isPageDenied() {
        const metaElement = document.querySelector("[name=pageID]");
        if(metaElement) {
            var pageId = metaElement.getAttribute("content").replace("{", "").replace("}","");;
            const pages = this.configuration.GetDeniedPages;
            for(var i = 0; i < pages.length; i++) {
                var page = pages[i];
                if(page == pageId)
                return true;
            }
        }
        

        return false;
    }

    hide() {
        document.getElementById(backgroundDivID).remove();
    }

    consentHtml(config) {
        const {
            text,
            settingsText,
            allowText,
            legalNoticeLink,
            legalNoticeText,
            allowRequiredText,
        } = config;
        return `
    <div class="cookie-consent">
        <span>${text}</span>
    <div class="cookie_buttons">
        <button class="${acceptRequiredClass}">${allowRequiredText}</button>
        <button class="${openSettingsClass}">${settingsText}</button>
        <button class="btn btn-link custom-btn-link ${acceptAllClass}">${allowText}</button>
    </div>
        <a class="cookie-consent__legal-notice" href="${legalNoticeLink}">${legalNoticeText}</a>
    </div>`;
    }
}
